import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import SnykConfigListing from './SnykConfigListing'
import SnykCredentialsForm from './SnykCredentialsForm'

export default function SnykPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={SnykCredentialsForm}
            PullConfigListingView={SnykConfigListing}
        />
    )
}
